import { render, staticRenderFns } from "./ShokurekishoPreview.vue?vue&type=template&id=38dfb85e&"
import script from "./ShokurekishoPreview.vue?vue&type=script&lang=js&"
export * from "./ShokurekishoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports